import { HttpInterceptorFn } from '@angular/common/http';
import { authInterceptor } from './services/interceptors/auth.interceptor';
import { errorNotificationInterceptor } from './services/interceptors/error-notification.interceptor';
import { loaderInterceptor } from './services/interceptors/loader.interceptor';
import { requestErrorHandlerInterceptor } from './services/interceptors/request-error-handler.interceptor';

export const interceptors: HttpInterceptorFn[] = [
  authInterceptor,
  loaderInterceptor,
  errorNotificationInterceptor,
  requestErrorHandlerInterceptor
];
